var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"custom-p-label",domProps:{"innerHTML":_vm._s(_vm.transform(this.str))}})
}
var staticRenderFns = []

export { render, staticRenderFns }